module.exports = __webpack_public_path__ + "img/SendBillButton.cbd6ed6c.svg";